export function removeFalsyValuesFromPayload<T extends object>(
  payload: T,
  additionalFalsyValues: string[] = []
): T {
  // clone query
  const _payload = { ...payload }
  // Remove falsy values and '*' from payload
  for (const key of Object.keys(_payload) as (keyof T)[]) {
    if (
      _payload[key] === undefined ||
      _payload[key] === null ||
      additionalFalsyValues.includes(String(_payload[key]))
    ) {
      delete _payload[key]
    }
  }
  return _payload
}
